module.exports = __webpack_public_path__ + "img/xuexi-bg.d37882a9.png";